'use strict';

import { routerReducer } from 'react-router-redux';
import { combineReducers } from 'redux';
import auth from './auth';
import corporations from './corporations';
import builders from './builders';
import subdivisions from './subdivisions';
import feeds from './feeds';
import lots from './lots';
import plans from './plans';
import globalMsg from './global-msg';
import globalModal from './global-modal';
import corporationFeeds from './corporation-feeds';
import reports from './reports';

export default graphqlClient =>
	combineReducers({
		auth,
		corporations,
		builders,
		subdivisions,
		feeds,
		lots,
		plans,
		globalMsg,
		globalModal,
		corporationFeeds,
		routing: routerReducer,
		reports,
		apollo: graphqlClient.reducer(),
	});



// WEBPACK FOOTER //
// ./src/assets/js/reducers/index.js